module.exports = __webpack_public_path__ + "img/shape.8fe47646.svg";